import React from 'react';
import { Tooltip } from '@mui/material';
import './tooltip.css';

const CustomTooltip = ({ title, children }) => {
  return (
    <Tooltip 
      title={title}
      placement="top"
      componentsProps={{
        popper: {
          sx: {
            '& .MuiTooltip-tooltip': {
              position: 'relative',
              '&::after': {
                display: 'none'
              }
            }
          }
        }
      }}
      classes={{
        tooltip: 'custom-tooltip',
        arrow: 'custom-arrow'
      }}
    >
      {children}
    </Tooltip>
  );
};

export default CustomTooltip; 